import { LockIcon } from '@/assets';
import { BackdropImage } from '@/components/ui/backdropImage';
import { Button } from '@/components/ui/button';
import { CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { routes } from '@/types/routes';
import { createFileRoute, Link, redirect } from '@tanstack/react-router';
import { Trans, useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_auth/(login)/mfa')({
  component: RouteComponent,
  beforeLoad: ({ context }) => {
    if (!context.auth.username || !context.auth.loginSession) {
      redirect({
        to: routes.login,
        replace: true,
        throw: true,
      });
    }
  },
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <>
      <CardHeader className="gap-space-2xs">
        <CardTitle className="text-heading-lg-semibold">
          { t('mfa.title', { ns: 'auth' }) }
        </CardTitle>
        <CardDescription className="text-body-md-normal">
          <Trans i18nKey="mfa.description" ns="auth" components={ { bold: <span className="font-semibold" /> } } />
        </CardDescription>
      </CardHeader>

      <CardContent className="flex flex-col items-center">
        <BackdropImage src={ LockIcon } className="my-space-md" />
        <Link to={ routes.verify } className="w-full">
          <Button className="w-full mt-space-lg">
            { t('buttons.continue', { ns: 'auth' }) }
          </Button>
        </Link>
      </CardContent>
    </>
  );
}
